import { ChangePasswordFormBody } from 'components/AbstractComponents/ModalChangePassword/ModalChangePassword.types.tsx';

export const changePasswordFormBodyInitialState: ChangePasswordFormBody = {
    password: '',
    repeatPassword: '',
}